import styled from 'styled-components';

export const MatchPasswordRulesContainer = styled.div`
  width: 200px;

  padding: 16px 8px 16px 24px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  background-color: ${(props) => props.theme.colors.greys.lighter};
  border-radius: 8px;
`;

export const CheckRules = styled.div`
  display: flex;
  flex-direction: column;

  gap: 16px;
`;

export const Rule = styled.div`
  display: flex;

  align-items: center;
  justify-content: flex-start;
`;

export const RuleCheck = styled.div`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${({ theme, $isValid }) =>
    $isValid ? theme.colors.brand.primary : theme.colors.greys.light};
  border-radius: 4px;
`;

export const RuleCheckIcon = styled.img`
  width: 12px;
`;

export const RuleMessage = styled.div`
  margin-top: 4px;

  color: ${(props) => props.theme.colors.greys.darkest};
  font: ${(props) => props.theme.fonts.textSmallHeight16};
`;

export default {
  MatchPasswordRulesContainer,
  CheckRules,
  Rule,
  RuleCheck,
  RuleCheckIcon,
  RuleMessage,
};
